import React, {useEffect, useState} from "react";
import './TableWithPagination.scss';
import {AddIcon, CloseIcon, EditIcon, FolderIcon} from "../LeadManagwIcons/LeadManagwIcons";
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";
import {toast} from "react-toastify";
import ModalEditLead from "./ModalEditLead";
import ModalCheckClose from "./ModalCheckClose";

const TableWithPagination = ({
                               data,
                               columns,
                               setLeadIdFromList,
                               setActiveTab,
                               defaultTowsPerPage,
                               setReRender,
                               hasCloseIcon,
                               closeFunction,
                               focusRowId
                             }) => {

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultTowsPerPage ? defaultTowsPerPage : 8);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editModeData, setEditModeData] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteModeData, setDeleteModeData] = useState("")

  const columnsWithIndexAndOperation = [
    {title: "ردیف", field: "index", width: "5%"},
    ...columns,
    {title: "عملیات", field: "operation"},
  ];

  const totalPages = Math.ceil(data.length / rowsPerPage);

  const currentData = data.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  useEffect(() => {
    if (focusRowId) {
      const focusIndex = data.findIndex((row) => row.id === focusRowId);
      if (focusIndex !== -1) {
        const focusPage = Math.ceil((focusIndex + 1) / rowsPerPage);
        setCurrentPage(focusPage);
      }
    }
  }, [focusRowId, data, rowsPerPage]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleEdit = async (id) => {
    const response = await _axios.get(prefixUrl() + "/sadenMarketingCRM/?request=leadSubmittedData&leadId=" + id)
    if (response?.data?.status) {
      setEditModeData(response.data.data)
      setShowEditModal(true);
    } else {
      toast.error(response.data.message)
    }
  };

  const handleFolder = (id) => {
    setLeadIdFromList(id)
    setActiveTab(3)
  };

  const handleAdd = (id) => {
    setLeadIdFromList(id)
    setActiveTab(2)
  };

  const handleClose = (id) => {
    setDeleteModeData(id)
    setShowDeleteModal(true)
  }

  try {
    return (
      <div className="table-container">

        <ul className="table-header">
          {columnsWithIndexAndOperation.map((col) => (
            <li
              className={"table-header-li"}
              key={col.field}
              style={{flex: col.width ? `0 0 ${col.width}` : "1"}}
            >
              {col.title}
            </li>
          ))}
        </ul>

        {currentData.length > 0 ?
          currentData.map((row, index) => (
            <ul
              className="table-row"
              key={index}
              style={{
                backgroundColor: row.colorCode || "#fff",
                border: +row.id === +focusRowId ? "3px solid #1B5C9CFF" : "none",
              }}
            >
              {columnsWithIndexAndOperation.map((col) => {
                if (col.field === "index") {
                  return (
                    <li
                      key={col.field}
                      style={{flex: col.width ? `0 0 ${col.width}` : "1"}}
                    >
                      {(currentPage - 1) * rowsPerPage + index + 1}
                    </li>
                  );
                }
                if (col.field === "operation") {
                  return (
                    <li
                      className={"table-row-li-button"}
                      key={col.field}
                      style={{flex: col.width ? `0 0 ${col.width}` : "1"}}
                    >
                      <button onClick={() => handleEdit(row.id)}><EditIcon/></button>
                      <button onClick={() => handleAdd(row.id)}><AddIcon/></button>
                      <button onClick={() => handleFolder(row.id)}><FolderIcon/></button>
                      {hasCloseIcon && <button onClick={() => handleClose(row.id)}><CloseIcon/></button>}
                    </li>
                  );
                }
                return (
                  <li
                    key={col.field}
                    style={{flex: col.width ? `0 0 ${col.width}` : "1"}}
                  >
                    {row[col.field] || "-"}
                  </li>
                );
              })}
            </ul>
          )) : <div className={"not-data-found"}>اطلاعاتی یافت نشد</div>
        }

        <div className="pagination">
          <div className={"total-data"}>تعداد کل : {data?.length}</div>
          <div className={"row-pagination-but"}>
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>قبلی</button>
            <span>
            {currentPage} از {totalPages}
          </span>
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>بعدی
            </button>
          </div>
          <select value={rowsPerPage} onChange={handleRowsPerPageChange}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        {showEditModal && <ModalEditLead onClose={() => setShowEditModal(false)}
                                         data={editModeData}
                                         setReRender={setReRender}/>}

        {showDeleteModal && <ModalCheckClose onClose={() => setShowDeleteModal(false)}
                                             setReRender={setReRender}
                                             closeFunction={closeFunction}
                                             data={deleteModeData}/>}
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default TableWithPagination;
